import React from 'react';
import { useEventHandler } from '../../../utils/EventBus/useEventHandler';
import { IClientFilterEmptyStateProps } from '../ClientFilterPage.interface';

export const ClientFilterEmptyState: React.FC<IClientFilterEmptyStateProps> = ({ EmptyStateComponent, onDataChange, pageTableId }) => {
    useEventHandler(pageTableId, onDataChange);
    return <EmptyStateComponent />;
};
